import { contactInfo } from '@/mocks/homeData';

export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h3 className="text-xs tracking-widest uppercase text-primary-500 font-medium mb-2">Get In Touch</h3>
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-950">联系我们</h2>
          <p className="mt-3 text-sm text-foreground-600 max-w-xl mx-auto">{contactInfo.description}</p>
        </div>

        <div className="max-w-2xl mx-auto">
          <div className="bg-background-100 rounded-lg p-8 border border-secondary-200/60">
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
              <div className="text-center">
                <div className="w-11 h-11 mx-auto flex items-center justify-center rounded-full bg-primary-100 text-primary-600 mb-3">
                  <i className="ri-mail-line text-xl"></i>
                </div>
                <h3 className="text-xs font-medium text-foreground-500 mb-1">电子邮箱</h3>
                <p className="text-sm font-heading text-foreground-800">{contactInfo.email}</p>
              </div>
              <div className="text-center">
                <div className="w-11 h-11 mx-auto flex items-center justify-center rounded-full bg-accent-100 text-accent-600 mb-3">
                  <i className="ri-wechat-line text-xl"></i>
                </div>
                <h3 className="text-xs font-medium text-foreground-500 mb-1">微信公众号</h3>
                <p className="text-sm font-heading text-foreground-800">{contactInfo.wechat}</p>
              </div>
              <div className="text-center">
                <div className="w-11 h-11 mx-auto flex items-center justify-center rounded-full bg-secondary-200 text-secondary-600 mb-3">
                  <i className="ri-qq-line text-xl"></i>
                </div>
                <h3 className="text-xs font-medium text-foreground-500 mb-1">QQ群</h3>
                <p className="text-sm font-heading text-foreground-800">{contactInfo.qq}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}